import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

// Types
export interface ScheduleCampaignRequest {
  platform_content_map?: { [platform: string]: number }; // Legacy format
  start_date: string;
  end_date: string;
  restaurant_id: string;
  flyer_id?: number;
  generated_content_id?: number;
  social_media?: string; // JSON string of platforms array
  scheduled_date?: string; // Unix timestamp as string
}

export interface UpdateCampaignRequest {
  restaurant_id: string;
  campaign_id: string;
  start_date: string;
  end_date: string;
  generated_content_id?: number;
  social_media: string;
  flyer_id?: number;
}

interface PlatformResult {
  platform: string;
  success: boolean;
  data?: any;
  error?: string;
}

interface ScheduleCampaignState {
  loading: boolean;
  success: boolean;
  error: string | null;
  data: {
    results?: PlatformResult[];
    successCount?: number;
    totalCount?: number;
  } | null;
}

const initialState: ScheduleCampaignState = {
  loading: false,
  success: false,
  error: null,
  data: null,
};

const scheduleCampaignSlice = createSlice({
  name: 'scheduleCampaign',
  initialState,
  reducers: {
    scheduleCampaignRequest: (state, _action: PayloadAction<ScheduleCampaignRequest>) => {
      state.loading = true;
      state.success = false;
      state.error = null;
    },
    scheduleCampaignSuccess: (state, action: PayloadAction<any>) => {
      state.loading = false;
      state.success = true;
      state.data = action.payload;
    },
    scheduleCampaignFailure: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.success = false;
      state.error = action.payload;
    },
    scheduleCampaignReset: (state) => {
      state.loading = false;
      state.success = false;
      state.error = null;
      state.data = null;
    },
    updateCampaignRequest: (state, _action: PayloadAction<UpdateCampaignRequest>) => {
      state.loading = true;
      state.success = false;
      state.error = null;
    },
    updateCampaignSuccess: (state, action: PayloadAction<any>) => {
      state.loading = false;
      state.success = true;
      state.data = action.payload;
    },
    updateCampaignFailure: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.success = false;
      state.error = action.payload;
    },
    fetchScheduledCampaignsRequest: (state, _action: PayloadAction<{ restaurant_id: string }>) => {
      state.loading = true;
    },
    fetchScheduledCampaignsSuccess: (state, action: PayloadAction<any>) => {
      state.loading = false;
      state.data = action.payload;
    },
    fetchScheduledCampaignsFailure: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const {
  scheduleCampaignRequest,
  scheduleCampaignSuccess,
  scheduleCampaignFailure,
  scheduleCampaignReset,
  updateCampaignRequest,
  updateCampaignSuccess,
  updateCampaignFailure,
  fetchScheduledCampaignsRequest,
  fetchScheduledCampaignsSuccess,
  fetchScheduledCampaignsFailure,
} = scheduleCampaignSlice.actions;

export default scheduleCampaignSlice.reducer;
